export default __webpack_public_path__ + "static/media/TrinLogo.30aa28a9.png";